import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridSortChangeEvent, GridHeaderCell } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    sort: SortDescriptor[];
    Instructors: InstructorData[];
    isLoading: boolean;
}

export interface InstructorData {
    InstructorId: number;
    InstructorNumber: string;
    Name: string;
    Email: string;
    CalendarColor: string;
}

class NameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/instructor/${this.props.dataItem.InstructorId}`}>
                    {this.props.dataItem.Name}
                </Link>
            </td>
        );
    }
}

class EmailCell extends GridCell {
    render() {
        return (
            <td>{<a href='mailto:{this.props.dataItem.Email}'>{this.props.dataItem.Email}</a>}</td>
        );
    }
}

class ColorCell extends GridCell {
    render() {
        return (
            <td>
                {this.props.dataItem.CalendarColor &&
                    <div style={{ margin: 'auto', width: 25, height: 25, backgroundColor: this.props.dataItem.CalendarColor, borderWidth: 1, borderColor: '#efefef', borderStyle: 'solid', borderRadius: '2em' }}></div>
                }
            </td>
        );
    }
}

class CenterHeader extends GridHeaderCell {
    render() {
        return (
            <p style={{textAlign: "center", margin: 0, padding: 0 }}>{this.props.title}</p>
        );
    }
  }

class Instructors extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            Instructors: [],
            isLoading: false,
            sort: [],
        };
        this.sortChange = this.sortChange.bind(this);
    }

    public componentWillMount() {
        this.getInstructors();
    }

    public render() {
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Instructors" />
            <div className="row">
                <div className="col">
                    <h1>Instructors</h1>
                </div>
                <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={'/instructor/0'}
                    >
                        Add Instructor
                    </Link>
                </div>
            </div>
            <Grid data={this.state.Instructors}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
            >
                <Column field="Name" title="Name" cell={NameCell} />
                <Column field="Email" title="E-Mail Address" cell={EmailCell} />
                <Column field="InstructorNumber" title="Id" />
                <Column field="Color" title="Calendar Color" cell={ColorCell} headerCell={CenterHeader} />
            </Grid>
            <br />
        </React.Fragment>;
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            Instructors: orderBy(this.state.Instructors, event.sort)
        });
    }

    private getInstructors() {
        this.setState({ isLoading: true });
        fetchApi('api/Instructor/List', {}, 'POST')
            .then((data: InstructorData[]) => {
                this.setState({ Instructors: data, isLoading: false });
            });
    }
}

export default Instructors;
